import { render, staticRenderFns } from "./aluminium_board_type.vue?vue&type=template&id=da30e59e"
import script from "./aluminium_board_type.vue?vue&type=script&lang=js"
export * from "./aluminium_board_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports